var map = {
	"./Fries-icon.svg": 40498,
	"./about-book.svg": 63240,
	"./about-documents.svg": 27279,
	"./about-hands.svg": 37779,
	"./app-store.svg": 82560,
	"./apporment-cleaning.svg": 88093,
	"./appstore-six.svg": 71508,
	"./arrow-eight-1.svg": 40142,
	"./arrow-eight-2.svg": 69261,
	"./bank-transfer.svg": 98515,
	"./banner-arrow.svg": 90645,
	"./banner-nine-dot.svg": 28248,
	"./banner-nine-icon-1.svg": 66966,
	"./banner-nine-icon-2.svg": 87253,
	"./book-done.svg": 32965,
	"./branch-icon-01.svg": 86993,
	"./branch-icon-02.svg": 6594,
	"./branch-icon-03.svg": 37171,
	"./branch-icon-04.svg": 80428,
	"./calendar-icon.svg": 48029,
	"./call-calling.svg": 38336,
	"./car-service-icon-1.svg": 68159,
	"./car-service-icon-2.svg": 96460,
	"./car-service-icon-3.svg": 76173,
	"./car-wash-header-1.svg": 76255,
	"./car-wash-header-2.svg": 97228,
	"./car-wash.svg": 90597,
	"./carpet-cleaning.svg": 35661,
	"./carpet.svg": 23834,
	"./category-01.svg": 95601,
	"./category-02.svg": 38498,
	"./category-03.svg": 42227,
	"./category-04.svg": 19660,
	"./category-05.svg": 67021,
	"./category-06.svg": 84046,
	"./category-07.svg": 98687,
	"./category-08.svg": 88472,
	"./category-09.svg": 13833,
	"./category-10.svg": 42755,
	"./category-11.svg": 28114,
	"./category-12.svg": 21249,
	"./category-13.svg": 85712,
	"./category-14.svg": 51599,
	"./category-15.svg": 7870,
	"./category-16.svg": 62045,
	"./category-17.svg": 72572,
	"./catering-01.svg": 116,
	"./catering-02.svg": 71623,
	"./catering-03.svg": 32086,
	"./catering-04.svg": 15769,
	"./catering-05.svg": 50376,
	"./catering-06.svg": 31739,
	"./catering-07.svg": 89770,
	"./catering-08.svg": 58045,
	"./cdn-globe-locations-svgrepo-com.svg": 12058,
	"./charges-1.svg": 95836,
	"./charges-2.svg": 74863,
	"./charges-3.svg": 12286,
	"./choose-icon-01.svg": 56774,
	"./choose-icon-1.svg": 51308,
	"./choose-icon-2.svg": 6655,
	"./choose-icon-3.svg": 1902,
	"./choose-icon-4.svg": 10897,
	"./cleaner-clean-svgrepo-com.svg": 74686,
	"./cleaner-svgrepo-com.svg": 69410,
	"./cleaning-mop.svg": 43233,
	"./commercial-cleaning.svg": 90583,
	"./computer.svg": 56236,
	"./construction.svg": 33552,
	"./consultation-icon-01.svg": 68194,
	"./consultation-icon-02.svg": 22737,
	"./consultation-icon-03.svg": 59936,
	"./consultation-icon-04.svg": 18495,
	"./consultation-icon-05.svg": 97390,
	"./consultation-icon-06.svg": 26509,
	"./coupon-icon.svg": 50265,
	"./covid-cleaning.svg": 12542,
	"./customer-quote.svg": 70724,
	"./cuttor-sm-white.svg": 56565,
	"./cuttor-small.svg": 61842,
	"./cuttor.svg": 79152,
	"./dog-face-eight.svg": 82829,
	"./dog-feet.svg": 44260,
	"./dog.svg": 63935,
	"./dropdown-nine.svg": 22609,
	"./dropdown.svg": 43556,
	"./expereience.svg": 32394,
	"./expert-team.svg": 48555,
	"./fb-icon.svg": 71987,
	"./fb.svg": 19599,
	"./feature-icon-01.svg": 69985,
	"./feature-icon-02.svg": 88242,
	"./feature-icon-03.svg": 21283,
	"./feature-icon-04.svg": 93628,
	"./feature-icon-05.svg": 22173,
	"./feature-icon-06.svg": 10078,
	"./feature-icon-07.svg": 72655,
	"./feature-icon-08.svg": 14504,
	"./feature-icon-09.svg": 79897,
	"./feature-icon-10.svg": 90547,
	"./feature-icon-11.svg": 59970,
	"./feature-icon-12.svg": 40369,
	"./feature-icon-13.svg": 83456,
	"./feature-icon-14.svg": 12831,
	"./find-icon.svg": 85412,
	"./flag-01.svg": 44623,
	"./flag-02.svg": 42300,
	"./flag-03.svg": 70845,
	"./flag-04.svg": 36914,
	"./global-nine.svg": 60991,
	"./global.svg": 57558,
	"./google-icon.svg": 68648,
	"./googleplay-six.svg": 16691,
	"./goolge-play.svg": 40947,
	"./group-stars.svg": 3792,
	"./gui-calendar-planner-eight.svg": 2094,
	"./gui-calendar-planner.svg": 86960,
	"./icon-upload.svg": 56946,
	"./instagram.svg": 44493,
	"./install-icon-01.svg": 41286,
	"./install-icon-02.svg": 77509,
	"./install-icon-03.svg": 99492,
	"./install-icon-04.svg": 47851,
	"./install-icon-05.svg": 42586,
	"./like-svg.svg": 91939,
	"./linkedin.svg": 41185,
	"./loc-bg.svg": 48061,
	"./loc-icon.svg": 79871,
	"./location.svg": 4198,
	"./mastercard.svg": 88939,
	"./mini-pink-feet.svg": 79651,
	"./money-cash-svgrepo-com.svg": 6626,
	"./move-in.svg": 54924,
	"./offer-icon-01.png": 6893,
	"./offer-icon.svg": 81119,
	"./office-cleaning.svg": 83589,
	"./painting.svg": 71419,
	"./pay-per-eight.svg": 79547,
	"./pay-solution.svg": 12669,
	"./payment-01.svg": 11817,
	"./payment-02.svg": 96730,
	"./payment-03.svg": 38168,
	"./payment-04.svg": 53636,
	"./payment1.svg": 89596,
	"./payment2.svg": 68623,
	"./paypal.svg": 59942,
	"./pink-dog-feet.svg": 54355,
	"./place-icon.svg": 35058,
	"./pointer-eight.svg": 66420,
	"./pricing-seven-1.svg": 81469,
	"./pricing-seven-2.svg": 27294,
	"./pricing-seven-3.svg": 89871,
	"./project-completed.svg": 32318,
	"./quality-svgrepo-com.svg": 85795,
	"./quote.png": 20129,
	"./quote.svg": 62937,
	"./razor-pay.svg": 36084,
	"./reviews-quote.svg": 78485,
	"./sallon-bg.jpg": 82716,
	"./sallon-bg.png": 30200,
	"./saloon-bg.svg": 79673,
	"./scan-six.svg": 63891,
	"./server-icon.svg": 1740,
	"./service-01.svg": 86492,
	"./service-02.svg": 65519,
	"./service-03.svg": 86590,
	"./service-04.svg": 46497,
	"./service-05.svg": 48048,
	"./service-icon-01.svg": 17330,
	"./service-icon-02.svg": 22369,
	"./service-icon-03.svg": 10128,
	"./service-icon-04.svg": 76015,
	"./service-icon-05.svg": 97086,
	"./shave.svg": 44512,
	"./sms.svg": 10114,
	"./sofa.svg": 82014,
	"./square.svg": 4990,
	"./star-01.svg": 99177,
	"./star-icon.svg": 5635,
	"./stripe.svg": 16520,
	"./style-logo.svg": 50894,
	"./success-01.svg": 81280,
	"./success-02.svg": 52179,
	"./success-03.svg": 89538,
	"./suitcase.svg": 86064,
	"./support.svg": 17444,
	"./test-quote.svg": 44776,
	"./tick-banner.svg": 94323,
	"./top-wave.png": 31496,
	"./trash-alt.svg": 28165,
	"./trim.svg": 96783,
	"./trophy-svgrepo-com.svg": 93256,
	"./twitter.svg": 97776,
	"./upload-icon.svg": 5818,
	"./vacuum-cleaner.svg": 60895,
	"./visa.svg": 29436,
	"./wallet-icon.svg": 29314,
	"./whatsapp.svg": 85345,
	"./win.svg": 16695,
	"./window-cleaner-detergent-svgrepo-com.svg": 63772,
	"./window-cleaner.svg": 64042,
	"./window-cleaning.svg": 27905,
	"./work-01.svg": 75736,
	"./work-02.svg": 33803,
	"./work-03.svg": 56282,
	"./work-icon-01.svg": 17278,
	"./work-icon-02.svg": 63549,
	"./work-icon-03.svg": 35004,
	"./work-icon-hand.svg": 59784,
	"./work-icon.svg": 77294,
	"./work-seven-1.svg": 22690,
	"./work-seven-2.svg": 59409,
	"./work-seven-3.svg": 23456,
	"./working-1.svg": 32002,
	"./working-2.svg": 52369,
	"./working-3.svg": 16416,
	"./working-4.svg": 82303,
	"./youtube.svg": 60774
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59945;